// For running the application locally, please update the below values with your local SSO configuration
const AUTH_CONFIG = {
    SSO_BASE_PATH: process.env.REACT_APP_SSO_BASE_PATH, //'https://ssoqa.landolakesinc.com'
    AUTHORISATION_URL: '/as/authorization.oauth2', 
    TOKEN_URL: '/as/token.oauth2',
	SSO_CLIENT_ID: process.env.REACT_APP_SSO_CLIENT_ID, //'159ee44f3b2641739520be674755af88',//
    GRANT_TYPE: 'authorization_code',
    GRANT_TYPE_REFRESH: 'refresh_token',
	RESPONSE_TYPE: 'code',
	SCOPE: 'openid',
    SSO_REDIRECT_URI: process.env.REACT_APP_SSO_REDIRECT_URI, //'http://localhost:4200' //,
}

export default AUTH_CONFIG;